import AstroImage from '@/components/ui/custom/AstroImage';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import useAuth from '@/data/hook/useAuth';
import Hackathon, { HackathonStage } from '@/models/Hackathon';
import { Breakpoints } from '@/utils/Breakpoint';
import HackathonStagesPermission from '@/utils/permissions/HackathonStagesPermission';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

type HackathonBannerInformationProps = {
  hackathon: Hackathon;
  hackathonStages?: HackathonStage[];
  resume?: boolean;
};

export default function HackathonBannerInformation({
  hackathon,
  hackathonStages = [],
  resume,
}: HackathonBannerInformationProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'hackathon.banner',
  });
  const { user } = useAuth();

  const hackathonStagesPermission = new HackathonStagesPermission({
    model: hackathonStages,
    user,
  });

  const isXs = useMediaQuery({
    minWidth: Breakpoints.xs,
  });
  return (
    <div className="flex flex-col">
      <div className="flex gap-5 items-start xs:items-center">
        <AstroImage
          src={hackathon.banner?.url ?? '/images/hackathon.png'}
          alternativesrc="/images/hackathon.png"
          width={isXs ? 171 : 55}
        />
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-0">
            <Text
              text={t('tematic')}
              className="text-16 sm:text-28 font-poppins font-600 text-hackathon-secondary"
            />
            <Text
              text={hackathon.title}
              className="text-16 sm:text-28 font-poppins font-600 text-hackathon-primary"
            />
          </div>
          <ConditionalRenderer condition={!resume}>
            <Text text={t('winnersPhrase')} className="text-14 sm:text-16" />
          </ConditionalRenderer>
        </div>
      </div>
      <ConditionalRenderer
        condition={
          hackathonStagesPermission.canShowFinalLivestream() &&
          hackathon.liveStreamUrl
        }
      >
        <div className="inline sm:flex gap-1 items-center w-full">
          <Text text={t('liveStream')} className="text-14" />
          <Text
            text={t('liveStreamLink')}
            href={hackathon.liveStreamUrl}
            className="text-14 underline text-primary"
          />
        </div>
      </ConditionalRenderer>
    </div>
  );
}
